<div class="component-with-sidebar">
    <div class="drive-summary-content" *ngIf="driveSummary">
        <!-- Header Section -->
        <div class="drive-summary-header">
            <div class="header-top">
                <div class="college-logo">
                    <img [src]="getDriveLogo(driveSummary.body.COLLEGE)" 
                         [alt]="collegeName" 
                         class="logo-image" />
                </div>
                <div class="header-info">
                    <h1 class="college-name">{{ collegeName }}</h1>
                    <div class="college-meta">
                        <span class="college-code">{{ driveSummary.body.COLLEGE }}</span>
                        <span class="separator">•</span>
                        <span class="year">{{ driveSummary.body.YEAR }}</span>
                        <span class="separator">•</span>
                        <span class="drive-id">{{ driveSummary.body.DRIVE_ID }}</span>
                    </div>
                </div>
            </div>
            <div class="status-section">
                <span [class]="getStatusClass(driveSummary.body.STATUS)">
                    {{ driveSummary.body.STATUS }}
                </span>
                <span class="ai-badge" *ngIf="isAiEnabled()">
                    <i class="pi pi-sparkles"></i> AI Enabled
                </span>
            </div>
        </div>

        <!-- Main Content Grid -->
        <div class="drive-summary-grid">
            <!-- Overview Card -->
            <div class="summary-card overview-card">
                <div class="card-header">
                    <h3><i class="pi pi-info-circle"></i> Overview</h3>
                </div>
                <div class="card-content">
                    <div class="info-row">
                        <div class="info-item">
                            <div class="info-label">Duration</div>
                            <div class="info-value">
                                <i class="pi pi-calendar"></i>
                                {{ driveSummary.body.FROM_DATE }} - {{ driveSummary.body.TO_DATE }}
                            </div>
                        </div>
                    </div>
                    <div class="info-row">
                        <div class="info-item">
                            <div class="info-label">Contact Person</div>
                            <div class="info-value">
                                <i class="pi pi-user"></i>
                                {{ driveSummary.body.CONTACT || 'N/A' }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Statistics Card -->
            <div class="summary-card stats-card">
                <div class="card-header">
                    <h3><i class="pi pi-chart-bar"></i> Statistics</h3>
                </div>
                <div class="card-content">
                    <div class="stats-grid">
                        <div class="stat-item">
                            <div class="stat-value">{{ driveSummary.body.TOTAL_COUNT }}</div>
                            <div class="stat-label">Total Candidates</div>
                        </div>
                        <div class="stat-item selected">
                            <div class="stat-value">{{ driveSummary.body.SELECTED_COUNT }}</div>
                            <div class="stat-label">Selected</div>
                        </div>
                        <div class="stat-item">
                            <div class="stat-value">{{ driveSummary.body.TOTAL_PANEL }}</div>
                            <div class="stat-label">Panels</div>
                        </div>
                    </div>
                    <div class="selection-rate" *ngIf="hasSelectionData()">
                        <div class="rate-label">Selection Rate</div>
                        <div class="rate-value">
                            {{ getSelectionRate() }}%
                        </div>
                    </div>
                </div>
            </div>

            <!-- Bar Raiser Questions Card -->
            <div class="summary-card questions-card" *ngIf="hasBarRaiserQuestions()">
                <div class="card-header">
                    <h3><i class="pi pi-question-circle"></i> {{ getBarRaiserTitle() }}</h3>
                </div>
                <div class="card-content">
                    <div class="questions-container">
                        <div class="question-category" *ngFor="let category of barRaiserCategories">
                            <div class="category-header">
                                <i class="pi pi-tag category-icon"></i>
                                <h4 class="category-title">{{ category.category }}</h4>
                                <span class="question-count">{{ category.questions.length }} questions</span>
                            </div>
                            <div class="questions-list">
                                <div class="question-item" *ngFor="let question of category.questions">
                                    <div class="question-number">{{ question.number }}</div>
                                    <div class="question-text">{{ question.text }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>